import { render, staticRenderFns } from "./partnerPortal.vue?vue&type=template&id=3866ee6a&scoped=true"
import script from "./partnerPortal.vue?vue&type=script&lang=js"
export * from "./partnerPortal.vue?vue&type=script&lang=js"
import style0 from "./partnerPortal.vue?vue&type=style&index=0&id=3866ee6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3866ee6a",
  null
  
)

export default component.exports